// hooks/useLeavePageLogic.js
import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import leaveApi from 'services/api/leaveApi';

const useLeavePageLogic = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState([]);
  const [onlyActive, setOnlyActive] = useState(false);
  const [category, setCategory] = useState("leave"); // leave | salary
  const [employeeType, setEmployeeType] = useState("permanent"); // permanent | contract
  const [editValues, setEditValues] = useState({});

  // Load settings from API
  const fetchSettings = async () => {
    setLoading(true);
    try {
      const settingsData = await leaveApi.getSettings({
        category,
        only_active: onlyActive,
      });
      setSettings(settingsData);

      // Initialize edit values depending on employee type
      const initialEditValues = settingsData.reduce((acc, setting) => {
        acc[setting.id] =
          employeeType === "permanent"
            ? setting.permanent_value
            : setting.contract_value;
        return acc;
      }, {});
      setEditValues(initialEditValues);
    } catch (err) {
      toast.error("Failed to load settings");
      console.error(err);
    }
    setLoading(false);
  };

  // Load data on component mount
  useEffect(() => {
    fetchSettings();
  }, [category, onlyActive, employeeType]);

  // Handle toggle active status
  const handleToggleActive = async (id) => {
    try {
      await leaveApi.toggleSetting(id, employeeType);
      toast.success("Setting updated");
      fetchSettings();
    } catch (err) {
      toast.error("Failed to update");
      console.error(err);
    }
  };

  // Handle update value
  const handleUpdateValue = async (id, newValue) => {
    try {
      await leaveApi.updateSettingValue(id, employeeType, newValue);
      toast.success("Value updated");
      fetchSettings();
    } catch (err) {
      toast.error("Failed to update value");
      console.error(err);
    }
  };

  return {
    // State
    isCollapsed,
    loading,
    settings,
    onlyActive,
    category,
    employeeType,
    editValues,
    
    // State setters
    setIsCollapsed,
    setOnlyActive,
    setCategory,
    setEmployeeType,
    setEditValues,
    
    // Functions
    fetchSettings,
    handleToggleActive,
    handleUpdateValue
  };
};

export default useLeavePageLogic;